import { render, staticRenderFns } from "./LetterTips.vue?vue&type=template&id=53944bb8&"
import script from "./LetterTips.vue?vue&type=script&lang=ts&"
export * from "./LetterTips.vue?vue&type=script&lang=ts&"
import style0 from "./LetterTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports